import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2
};

const strokePropsRound = {
  ...strokeProps,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const TagIcon = createSvgIcon(
  <>
    <path
      d="M13.4002 3.39973C14.063 3.39973 14.6003 3.93701 14.6003 4.59977C14.6003 5.26253 14.063 5.7998 13.4002 5.7998C12.7375 5.7998 12.2002 5.26253 12.2002 4.59977C12.2002 3.93701 12.7375 3.39973 13.4002 3.39973Z"
      {...strokePropsRound}
    />
    <path
      d="M1.61913 8.31502C0.816704 9.21105 0.799903 10.5631 1.53593 11.5151C2.96558 13.371 4.629 15.0344 6.48488 16.4641C7.43691 17.2001 8.78895 17.1833 9.68498 16.3809C12.1071 14.2143 14.3831 11.8897 16.498 9.42226C16.7115 9.17685 16.843 8.87084 16.874 8.54703C17.0052 7.11018 17.2764 2.97085 16.1524 1.84762C15.0283 0.724385 10.8898 0.994793 9.45297 1.1268C9.12916 1.15782 8.82315 1.28929 8.57775 1.50281C6.11037 3.61744 3.78574 5.89316 1.61913 8.31502Z"
      {...strokeProps}
    />
    <path d="M5 10.5999L7.40007 12.9999" {...strokePropsRound} />
  </>,
  { displayName: 'TagIcon', viewBox: '0 0 18 18' }
);
